import React, { Component } from 'react'
import api from 'api';
import { connect } from 'react-redux';
import Modal from '../components/Modal';
import CheckedSelect from '../components/checked-select/CheckedSelect';
import { createTag } from '../reducers/tags';

var updateClientTags = (tags) => ({
    type: 'UPDATE_CLIENT_TAGS',
    tags
});

@connect(
    state => ({
        tags: state.tags.tags
    }),
    {createTag, updateClientTags}
)
export default class TagsModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            tagsSelected: props.client.tags.map(t => t.id)
        }
    }
    saveTag() {
        var name = this.tagInput.value;
        if(name) {
            this.props.createTag({name}).then(tagAction => {
                var newTagId = tagAction.result.id;
                this.handleChange(
                    this.state.tagsSelected.concat(newTagId)
                );
            });
            this.tagInput.value = '';
        }
    }
    handleChange(tagsSelected) {
        var tags = this.props.tags.filter(t => tagsSelected.includes(t.id));
        this.props.updateClientTags(tags);
        this.setState({tagsSelected});

        api.post(`clients/${this.props.client.id}/assign_tags`, {tagsSelected});
    }
    handleSubmit(e) {
        e.preventDefault();
        this.saveTag();
    }
    render() {
        return (
            <Modal className="modal-success"  title={"Tags"}>
                <h2>Tags for {this.props.client.name}</h2>
                <CheckedSelect
                    onChange={this.handleChange.bind(this)}
                    tagsSelected={this.state.tagsSelected}
                    tags={this.props.tags} />

                <h2>Add new tag</h2>
                <form style={{display: 'flex'}} onSubmit={this.handleSubmit.bind(this)}>
                    <input defaultValue="" ref={i => this.tagInput = i} style={{paddingLeft: 10, flex: 1}} placeholder="Enter tag name" />
                    <button onClick={this.saveTag.bind(this)} className="btn btn-success">Add tag</button>
                </form>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/TagsModal.js